import {User} from '@/domain/entities/User';
import authRepository from '@/domain/repository/AuthRepository';

export const getLoggedUser = async (): Promise<User | undefined> => {
  try {
    return authRepository.me();
  } catch (error) {
    console.error('Error fetching logged user', error);
    return undefined;
  }
};